import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Alert } from '@mui/material';
import './AdminComponents.css';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? window.location.origin
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001');

const MostViewedProjects = () => {
    const { token } = useAuth();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMostViewedProjects = async () => {
            try {
                setLoading(true);
                setError(null);

                const response = await fetch(`${API_BASE_URL}/api/stats/projects/most-viewed`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Erreur lors de la récupération des projets les plus vus');
                }

                const data = await response.json();
                setProjects(data);
            } catch (err) {
                console.error('Erreur lors du chargement des projets les plus vus:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchMostViewedProjects();
    }, [token]);

    if (loading) {
        return (
            <div className="stats-card most-viewed-card">
                <h3>Projets les plus vus</h3>
                <div className="loading-container">
                    <CircularProgress />
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="stats-card most-viewed-card">
                <h3>Projets les plus vus</h3>
                <Alert severity="error">{error}</Alert>
            </div>
        );
    }

    return (
        <div className="stats-card most-viewed-card">
            <h3>Projets les plus vus</h3>
            <div className="most-viewed-list">
                {projects.map((project, index) => (
                    <div key={project.id} className="most-viewed-item">
                        <span className="most-viewed-number">{index + 1}</span>
                        <div className="most-viewed-info">
                            <span className="most-viewed-title">{project.title}</span>
                            <span className="most-viewed-address">
                                {project.address}, {project.zipcode} {project.ville}, {project.pays}
                            </span>
                        </div>
                        <span className="most-viewed-count">{project.views} vues</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MostViewedProjects; 